import { render } from "./SwipeBox.vue?vue&type=template&id=512dc721"
import script from "./SwipeBox.vue?vue&type=script&lang=js"
export * from "./SwipeBox.vue?vue&type=script&lang=js"

import "./SwipeBox.vue?vue&type=style&index=0&id=512dc721&lang=css"

import exportComponent from "/home/behnam/Desktop/tr/vue3-swipe-box/vue3-swipe-box/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__